module.exports = __webpack_public_path__ + "static/media/reflection.b1ce8e47.mp3";